import * as React from "react"
import { Block } from "./library/container"

export interface ImageBlockProps {
  readonly imageUrl: string
  readonly imageUrlSmall: string
  readonly imageUrlLarge: string
  readonly imageAlt: string
}

export const ImageBlock: React.StatelessComponent<ImageBlockProps> = p => (
  <Block>
    <div className="block block--image block--media container--mg align--center">
      <div className="block__visual">
        <img
          src="/bkw/images/bkw/empty.png"
          data-src={p.imageUrlSmall}
          data-srcset={`${p.imageUrlSmall} 400w, ${p.imageUrl} 800w, ${p.imageUrlLarge} 1600w`}
          alt={p.imageAlt}
          width="100%"
          className="block__image lazyload"
        />
      </div>
    </div>
  </Block>
)

{/* TH: Added to styleguide! */}

